import { useCategorySlideContext } from "@/components/Navigation/Sidebar/components/assortiment/components/categorySlide/context/categorySlide.context";

import { Base } from "./categorySlide.base";
import { Back } from "./components/back";
import { Header } from "./components/header";

export const CategorySlide = Object.assign(Base, {
    useContext: useCategorySlideContext,
    Back: Back,
    Header: Header
});
